// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const AfterpayMessagingDemo: MarkdocTagRegistration = {
  tag: 'afterpay-messaging-demo',
  component: 'AfterpayMessagingDemo',
  attributes: {
    part: {
      type: String,
      default: 'product',
      description: 'Which part of the AfterpayMessagingDemo to display.',
    },
  },
};
